module.exports = __webpack_public_path__ + "static/media/icon-02.d44ca003.png";